import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import storeLoader from 'app/stores/storeLoader';
import { Field, formConsumer, RadioGroup } from 'core/form';
import { Box, Flex, Heading, Callout } from 'core/components';
import { buildLandingPageTypeOptions } from 'app/util/landingPage/landingPage';

@storeLoader('$boards', '$dashboards', '$savedViews')
@inject('$auth', '$dictionary', '$app', '$boards')
@formConsumer
@observer
export default class RoleSetLandingPage extends Component {
  getLandingPageTypeOptions = (form) => {
    const { $auth, $savedViews, $boards } = this.props;

    const boardOptions = $boards.assignableBoards.map((model) => model.selectOptionFormat);
    const savedViewOptions = $savedViews.collection.generateSelectOptions({ labelKey: 'view_name' });

    return [
      { label: 'User Local (default)', value: 'local' },
      ...buildLandingPageTypeOptions({
        currentType: form.getValue('config.landingPageType'),
        boardOptions,
        savedViewOptions,
        hasMarketIntel: $auth.hasPermission('marketIntel.enabled'),
        hasAiAdvisor: $auth.hasAiAdvisorAccess,
        valueFieldName: 'config.landingPageValue',
        menuWidth: 'auto'
      })
    ];
  };

  onLandingPageTypeChange = () => {
    const { form } = this.props;
    form.getField('config.landingPageValue').init(undefined);
  };

  render() {
    const { form } = this.props;
    return (
      <Box mt={2}>
        <Heading level={6}>Default Settings</Heading>
        <Callout p={2}>
          <Flex>
            <Box>
              <Field
                mb={0}
                name="config.landingPageType"
                large
                options={this.getLandingPageTypeOptions(form)}
                onChange={this.onLandingPageTypeChange}
              >
                <RadioGroup large />
              </Field>
            </Box>
            <Box flex={1} />
          </Flex>
        </Callout>
      </Box>
    );
  }
}
